/**
 * MagPub (Payload) persists admin theme in a `payload-theme` cookie.
 * Magnus owns preference via next-themes (`localStorage` key `theme`);
 * write this cookie whenever Magnus resolves light/dark so MagPub SSR
 * and Payload's ThemeProvider pick up the same preference.
 *
 * Mirror of Payload's setCookie in `@payloadcms/ui` Theme provider.
 */
export const PAYLOAD_THEME_COOKIE_KEY = "payload-theme";

export function writePayloadThemeCookie(theme: "light" | "dark"): void {
  if (typeof document === "undefined") {
    return;
  }
  const expires = new Date();
  expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
  document.cookie = `${PAYLOAD_THEME_COOKIE_KEY}=${theme};expires=${expires.toUTCString()};path=/`;
}
